<template>
  <div class="fc-container">
    <div class="fc-title">
      <h3>人氣品牌</h3>
      <span class="title-underline"></span>
    </div>
    <div class="content">
      <VueSlickCarousel
        :arrows="true"
        :slidesToShow="carouselRows"
        :swipeToSlide="true"
      >
        <div
          class="itemBox"
          v-for="(item,index) in imgList"
          :key="index"
        >
          <img
            :src="item"
            alt=""
          >
          {{index}}
        </div>
      </VueSlickCarousel>
    </div>
  </div>
</template>

<script>

import VueSlickCarousel from 'vue-slick-carousel'
import 'vue-slick-carousel/dist/vue-slick-carousel.css'
import 'vue-slick-carousel/dist/vue-slick-carousel-theme.css'

export default {
  props: {
    imgList: {
      type: Array,
      default: () => new Array(7)
    }
  },
  data () {
    return {
      carouselRows: 5,
      resizeFn: null
    }
  },
  methods: {
    // 防抖函数
    debounce (fn, delay) {
      let timer = null
      return () => {
        if (timer) {
          clearTimeout(timer)
        }
        timer = setTimeout(fn, delay)
      }
    },
    getRows () {
      // 得到屏幕宽度
      const width = window.innerWidth
      if (width >= 1200) {
        this.carouselRows = 5
      } else if (width >= 997) {
        this.carouselRows = 4
      } else if (width >= 768) {
        this.carouselRows = 3
      } else {
        this.carouselRows = 2
      }
    }
  },
  mounted () {
    // 添加屏幕监听
    this.getRows()
    this.resizeFn = this.debounce(this.getRows, 200)
    window.addEventListener('resize', this.resizeFn)
  },
  beforeDestroy () {
    window.removeEventListener('resize', this.resizeFn)
  },
  components: {
    VueSlickCarousel
  }
}
</script>

<style lang="scss" scoped>
.fc-container {
  background-color: #e8e8e8;
  padding: 50px 0;
  .fc-title {
    display: flex;
    flex-direction: column;
    align-items: center;
    > h3 {
      font-size: 20px;
      font-weight: lighter;
    }
    .title-underline {
      position: relative;
      width: 40px;
      height: 5px;
      border-radius: 3px;
      background-color: #ffbf00;
      transform: translateX(-5px);
      &::after {
        content: "";
        position: absolute;
        right: -10px;
        width: 5px;
        height: 5px;
        border-radius: 50%;
        background-color: #ffbf00;
      }
    }
  }
  .content {
    margin: 37px auto 0;
    max-width: 1072px;
    .itemBox {
      max-width: 150px;
      min-width: 150px;
      height: 150px;
      border-radius: 50%;
      background-color: #fff;
    }
    ::v-deep .slick-arrow {
      width: 50px;
      height: 50px;
      &::before {
        font-size: 50px;
      }
    }
    ::v-deep .slick-prev {
      left: -55px;
    }
    ::v-deep.slick-next {
      right: -55px;
    }
    @media screen and (max-width: 1280px) {
      width: 70%;
    }
    @media screen and (max-width: 997px) {
      width: 60%;
    }
    @media screen and (max-width: 768px) {
      width: 60%;
      .itemBox {
        max-width: 100px;
        min-width: 100px;
        height: 100px;
      }
    }
  }
}
</style>